import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {CouponLandingPageService_GetCategoryTreeNavigationLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coupons/v1/landingpage/service.grpc.lazy';
import {useParams} from '@aboutyou/router';
import {useFullSession} from '@aboutyou/user';
import {useAppliedPotentialFilters} from '../../../features/ProductStream/utils';
import {useReductionsStateRequestParameter} from '../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';
import {useCategoryIdentifier} from '../hooks/useCategoryIdentifier';

export const useCouponLandingPageCategoryTreeNavigation = () => {
  const session = useFullSession();
  const targetGroup = useTargetGroupIdentifier();
  const reductionsState = useReductionsStateRequestParameter();
  const categoryIdentifier = useCategoryIdentifier();
  const appliedFilters = useAppliedPotentialFilters();
  const {promotionId} = useParams();

  return useGrpcRequest(
    CouponLandingPageService_GetCategoryTreeNavigationLazy,
    {
      session: session!,
      targetGroup,
      reductionsState,
      category: categoryIdentifier,
      appliedFilters: {
        filters: appliedFilters,
      },
      couponPromotionId: promotionId!,
    },
    {
      keepPreviousData: true,
      disabled: !session || !promotionId,
    },
  );
};
